import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Masthead from '../components/homepage/Masthead';
import HomeIntroSection from '../components/homepage/HomeIntroSection';
import PortfolioSection from '../components/homepage/PortfolioSection';
import ServicesSection from '../components/homepage/ServicesSection';

/**
 * Homepage Component
 */
function HomePage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const sectionId = hash.replace('#', '');
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [hash]);

  return (
    <>
      <Masthead />
      <HomeIntroSection />
      <PortfolioSection />
      <ServicesSection />
    </>
  );
}

export default HomePage;
